import { HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { HttpInterceptor } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';

import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { LogService } from '../service/log.service';
import { SessionService } from '../service/auth/session.service';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  constructor(private sessionService: SessionService,
              private logService: LogService) { }

  intercept(req: HttpRequest<any>,
            next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req)
              .pipe(tap(res => {
                if (res instanceof HttpResponse) {
                  this.logService
                      .log('Response ' + req.url);

                  this.handleVersion(res);
                }
              }),
              catchError((error: HttpErrorResponse) => {
                if (error.status === 401 /* &&
                    this.sessionService.isValid()*/) {
                      console.log('Forbidden, force logout');
                      this.sessionService
                          .logout('Please login to continue');
                } else if (error.status === 403) { // Forbidden

                  if (!error.error) {
                    error = this.setUserFriendlyMessage(error,
                                                        'Unfortunately you don\'t have the necessary access');
                  }

                } else if (error.status === 503) { // Forbidden

                  if (!error.error) {
                    error = this.setUserFriendlyMessage(error,
                                                        'Oops, currently running maintenance, please retry');
                  }

                } else if (error.status === 502) { // Bad Gateway

                  if (!error.error) {
                    error = this.setUserFriendlyMessage(error,
                                                      'Humm, cannot get there, please retry');
                    }

                } else if (error.status === 504) { // Gateway timeout

                  if (!error.error) {
                    error = this.setUserFriendlyMessage(error,
                                                        'That took longer than expected, please retry');
                  }
                }

                return throwError(error);
              }));
  }

  private handleVersion(res: HttpResponse<any>): void {
    res.headers.keys();

    const version = res.headers.get('portal-version');

    if (version != null &&
        version !== undefined) {

      const oldVersion = this.sessionService.version;

      if (oldVersion){

        if (version !== oldVersion) {
          this.logService
              .log('Portal upgrade: ' + version);

          this.sessionService
              .version = version;

          location.reload();
        }

      } else {
        this.sessionService
            .version = version;
      }
    }
  }

  private setUserFriendlyMessage(error: HttpErrorResponse,
                                 message: string): HttpErrorResponse {

    return new HttpErrorResponse({error: message,
                                  headers: error.headers,
                                  statusText: error.statusText,
                                  status: error.status,
                                  url: error.url ? error.url : undefined});
  }
}
